import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import {
  RECHERCHE_ENTREPRISES_API_PROXY_ENDPOINT,
  createRechercheEntreprisesFetcher,
} from '@e-socna/organization-search';

import { environment } from '../../../environment';

import type { OrganizationSearchResponse } from '../types/organization-search-result.type';

const MIN_QUERY_LENGTH = 3;

const rechercheEntreprisesFetch = createRechercheEntreprisesFetcher('search');

interface Params {
  readonly query: string;
}

export const useOrganizationSearchQuery = ({ query }: Readonly<Params>) => {
  const trimmedQuery = query.trim();
  const enabled = trimmedQuery.length >= MIN_QUERY_LENGTH;

  const { fetcher } = useMemo(() => {
    const queryString = new URLSearchParams({ q: trimmedQuery }).toString();

    const url = `${environment.backendUrl}${RECHERCHE_ENTREPRISES_API_PROXY_ENDPOINT}/search?${queryString}`;

    return {
      fetcher: () => rechercheEntreprisesFetch<OrganizationSearchResponse>(url),
    };
  }, [trimmedQuery]);

  const queryResult = useQuery({
    queryKey: ['useOrganizationSearchQuery', trimmedQuery],
    queryFn: fetcher,
    enabled,
  });

  return { ...queryResult, enabled };
};
